var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _g5, _rect8, _g6, _rect9, _g7, _rect10, _rect11, _g8, _rect12, _g9, _rect13, _g10, _rect14, _g11, _rect15, _g12, _rect16, _g13, _rect17, _g14, _rect18, _rect19, _g15, _rect20, _g16, _rect21, _g17, _rect22, _g18, _rect23, _g19, _rect24, _g20, _rect25, _g21, _rect26, _rect27, _g22, _rect28, _g23, _rect29, _g24, _rect30, _g25, _rect31, _g26, _rect32, _g27, _rect33, _g28, _rect34, _rect35, _g29, _rect36, _g30, _rect37, _g31, _rect38, _g32, _rect39, _g33, _rect40, _g34, _rect41, _g35, _rect42, _rect43, _g36, _rect44, _g37, _rect45, _g38, _rect46, _g39, _rect47, _g40, _rect48, _g41, _rect49, _g42, _path7, _path8, _path9, _path10, _rect50, _rect51, _g43, _rect52, _g44, _rect53, _g45, _rect54, _g46, _rect55, _g47, _rect56, _g48, _rect57, _g49, _rect58, _rect59, _g50, _rect60, _g51, _rect61, _g52, _rect62, _g53, _rect63, _g54, _rect64, _g55, _rect65, _g56, _rect66, _rect67, _g57, _rect68, _g58, _rect69, _g59, _rect70, _g60, _rect71, _g61, _rect72, _g62, _rect73, _g63, _rect74, _rect75, _g64, _rect76, _g65, _rect77, _g66, _rect78, _g67, _rect79, _g68, _rect80, _g69, _rect81, _g70, _path11, _path12, _path13, _path14, _rect82, _rect83, _g71, _rect84, _g72, _rect85, _g73, _rect86, _g74, _rect87, _g75, _rect88, _g76, _rect89, _g77, _rect90, _rect91, _g78, _rect92, _g79, _rect93, _g80, _rect94, _g81, _rect95, _g82, _rect96, _g83, _rect97, _g84, _rect98, _rect99, _g85, _rect100, _g86, _rect101, _g87, _rect102, _g88, _rect103, _g89, _rect104, _g90, _rect105, _g91, _rect106, _rect107, _g92, _rect108, _g93, _rect109, _g94, _rect110, _g95, _rect111, _g96, _rect112, _g97, _rect113, _g98;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDataViewNone = function SvgDataViewNone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 99,
    viewBox: "0 0 160 99",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 98,
    rx: 2.5,
    fill: "white",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 16.967L148.451 16.9358",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 10.0664L148.451 10.0351",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 33.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 12,
    width: 13,
    height: 3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 12.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 12.8418,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.3193,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 12,
    width: 11,
    height: 3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 12.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 11.3193,
    width: 16.3403,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 12,
    width: 14,
    height: 3
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 12.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 11.3193,
    width: 19.791,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 12,
    width: 8,
    height: 3
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 12.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 11.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 12,
    width: 8,
    height: 3
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 12.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 11.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 12,
    width: 14,
    height: 3
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 12.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 11.3193,
    width: 19.791,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 12,
    width: 7,
    height: 3
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 12.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 11.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 18,
    width: 13,
    height: 3
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 18.9313,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 18.9314,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17.4089,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 18,
    width: 14,
    height: 3
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 18.9314,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 17.4089,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 18,
    width: 11,
    height: 3
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 18.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 17.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 18,
    width: 10,
    height: 3
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 18.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 17.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 18,
    width: 10,
    height: 3
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 18.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 17.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 18,
    width: 11,
    height: 3
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 18.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 17.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 18,
    width: 9,
    height: 3
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 18.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 17.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 24,
    width: 13,
    height: 2
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 24.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 24.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 24,
    width: 14,
    height: 2
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 24.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 22.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 24,
    width: 11,
    height: 2
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 24.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 22.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 24,
    width: 10,
    height: 2
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 24.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 22.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 24,
    width: 10,
    height: 2
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 24.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 22.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 24,
    width: 11,
    height: 2
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 24.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 22.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 24,
    width: 9,
    height: 2
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 24.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 22.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 29,
    width: 13,
    height: 3
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 29.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 29.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 29,
    width: 14,
    height: 3
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 29.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 28.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 29,
    width: 11,
    height: 3
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 29.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 28.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 29,
    width: 10,
    height: 3
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 29.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 28.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 10,
    height: 3
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 29.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 28.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 29,
    width: 11,
    height: 3
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 29.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 28.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 29,
    width: 9,
    height: 3
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 29.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 28.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 35,
    width: 13,
    height: 2
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 35.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 35.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 35,
    width: 14,
    height: 2
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 35.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 33.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 35,
    width: 11,
    height: 2
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 35.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 33.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 35,
    width: 10,
    height: 2
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 35.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 33.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 35,
    width: 10,
    height: 2
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 35.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 33.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 35,
    width: 11,
    height: 2
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 35.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 33.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 35,
    width: 9,
    height: 2
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 35.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 33.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 40,
    width: 13,
    height: 3
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 40.9551,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 40.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 39.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 40,
    width: 14,
    height: 3
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 40.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 39.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 40,
    width: 11,
    height: 3
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 40.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 39.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 40,
    width: 10,
    height: 3
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 40.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 39.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 40,
    width: 10,
    height: 3
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 40.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 39.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 40,
    width: 11,
    height: 3
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 40.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 39.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 40,
    width: 9,
    height: 3
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 40.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 39.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 60.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 49.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 46,
    width: 13,
    height: 2
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 46.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 46.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 44.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 46,
    width: 14,
    height: 2
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 46.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 44.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 46,
    width: 11,
    height: 2
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 46.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 44.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 46,
    width: 10,
    height: 2
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 46.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 44.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 46,
    width: 10,
    height: 2
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 46.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 44.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 46,
    width: 11,
    height: 2
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 46.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 44.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 46,
    width: 9,
    height: 2
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 46.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 44.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 51,
    width: 13,
    height: 3
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 51.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 51.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 50.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 51,
    width: 14,
    height: 3
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 51.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 50.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 51,
    width: 11,
    height: 3
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 51.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 50.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 51,
    width: 10,
    height: 3
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 51.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 50.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 51,
    width: 10,
    height: 3
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 51.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 50.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 51,
    width: 11,
    height: 3
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 51.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 50.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 51,
    width: 9,
    height: 3
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 51.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 50.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 57,
    width: 13,
    height: 2
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 57.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 57.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 55.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 57,
    width: 14,
    height: 2
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 57.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 55.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 57,
    width: 11,
    height: 2
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 57.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 55.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 57,
    width: 10,
    height: 2
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 57.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 55.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 57,
    width: 10,
    height: 2
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 57.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 55.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 57,
    width: 11,
    height: 2
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 57.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 55.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 57,
    width: 9,
    height: 2
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 57.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 55.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 62,
    width: 13,
    height: 3
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 62.9551,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 62.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 61.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 14,
    height: 3
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 62.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 61.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 62,
    width: 11,
    height: 3
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 62.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 61.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 62,
    width: 10,
    height: 3
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 62.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 61.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 62,
    width: 10,
    height: 3
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 62.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 61.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 62,
    width: 11,
    height: 3
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 62.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 61.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 62,
    width: 9,
    height: 3
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 62.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 61.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 71.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9 77.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 68,
    width: 13,
    height: 2
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 68.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 68.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 68,
    width: 14,
    height: 2
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 68.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 66.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 68,
    width: 11,
    height: 2
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 68.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 66.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 68,
    width: 10,
    height: 2
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 68.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 66.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 68,
    width: 10,
    height: 2
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 68.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 66.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 68,
    width: 11,
    height: 2
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 68.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 66.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 68,
    width: 9,
    height: 2
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 68.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 66.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 73,
    width: 13,
    height: 3
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 73.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 73.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 72.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 73,
    width: 14,
    height: 3
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 73.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 72.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 73,
    width: 11,
    height: 3
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 73.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 72.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 73,
    width: 10,
    height: 3
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 73.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 72.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 73,
    width: 10,
    height: 3
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 73.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 72.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 73,
    width: 11,
    height: 3
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 73.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 72.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 73,
    width: 9,
    height: 3
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 73.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 72.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 79,
    width: 13,
    height: 2
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 79.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 79.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 77.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 79,
    width: 14,
    height: 2
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 79.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 77.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 79,
    width: 11,
    height: 2
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 79.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 77.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 79,
    width: 10,
    height: 2
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 79.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 77.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 79,
    width: 10,
    height: 2
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 79.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 77.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 79,
    width: 11,
    height: 2
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 79.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 77.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 79,
    width: 9,
    height: 2
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 79.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 77.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 84,
    width: 13,
    height: 3
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 84.9551,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 84.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 83.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 84,
    width: 14,
    height: 3
  }, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 84.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 83.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 84,
    width: 11,
    height: 3
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 84.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 83.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 84,
    width: 10,
    height: 3
  }, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 84.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 83.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 84,
    width: 10,
    height: 3
  }, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 84.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 83.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 84,
    width: 11,
    height: 3
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 84.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 83.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1403_19730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 84,
    width: 9,
    height: 3
  }, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 84.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1403_19730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 83.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataViewNone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-view-none.9cf287b5.svg";
export { ForwardRef as ReactComponent };